module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"change":"Изменить","or-drag-it-here":"или перетащите его сюда","image-uploaded":"Изображение загружено","image-not-uploaded":"Изображение не загружено"},"en":{"change":"Change","or-drag-it-here":"or drag it here","image-uploaded":"Image is uploaded","image-not-uploaded":"Image is not uploaded"}}')
  delete Component.options._Ctor
}
